import { render, staticRenderFns } from "./StakingPage.vue?vue&type=template&id=91f6a282&scoped=true&"
import script from "./StakingPage.vue?vue&type=script&lang=js&"
export * from "./StakingPage.vue?vue&type=script&lang=js&"
import style0 from "./StakingPage.vue?vue&type=style&index=0&id=91f6a282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f6a282",
  null
  
)

export default component.exports